import { AxiosInstance } from 'axios';

const StorageServiceFactory = ({ HTTPBase }: { HTTPBase: AxiosInstance }) => {
  return {
    getResourcesInfo: (): Promise<any> => HTTPBase.get('users/navigator?sections=resources').then((res) => res.data),
    getFile: (path: string): Promise<any> => HTTPBase.get('files', { params: { path } }).then((res) => res.data),
  };
};

export default StorageServiceFactory;
